module.exports = __webpack_public_path__ + "img/odeon_logo_on_white.a813a2b7.png";